<template>
  <div class="clouddiskone">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">我的云盘</a></li>
          <li class="">
            <router-link to="/home/geturl">下载链接导出</router-link>
          </li>
          <li class="fr">
            <router-link to="/home/cloudDisk">全部文件夹</router-link> > <router-link
              :to="{name: 'cloudDisk', params: { type: type }}">{{type === 0 ? '遥感数据' : '遥感产品'}}</router-link> > <a
              href="javascript:void(0)">{{orderCode}}</a>
          </li>
        </ul>
      </nav>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" class="messagelist" :row-class-name="tableRowClassName">
      <el-table-column label="文件名" width="380">
        <template slot-scope="scope">
          <i class="txticon" v-if="scope.row.fileName.endsWith('.txt')"></i><a v-if="scope.row.fileName==='下载链接列表.txt'"
            :title="scope.row.name" href="javascript:void(0);"
            @click="showDownloadLink(scope.row,'下载链接：')">{{ scope.row.fileName }}</a>
          <a v-else-if="scope.row.fileName==='文件校验列表.txt'" :title="scope.row.name" href="javascript:void(0);"
            @click="showDownloadLink(scope.row,'校验信息：')">{{ scope.row.fileName }}</a>
          <i class="zipicon" v-if="!scope.row.fileName.endsWith('.txt')"></i><span
            v-if="!scope.row.fileName.endsWith('.txt')" class="file-name"
            :title="scope.row.fileName">{{ scope.row.fileName }}</span>
          <el-dialog v-if="title==='下载链接：'" custom-class="txtDialog" :title="title" :visible.sync="txtFormVisible"
            append-to-body :close-on-click-modal="false">
            <span style="white-space:pre-line;">{{content}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="copyUrl(0)">复制链接</el-button>
            </span>
          </el-dialog>
          <el-dialog v-else custom-class="txtDialog" :title="title" :visible.sync="txtFormVisible" append-to-body
            :close-on-click-modal="false">
            <span style="white-space:pre-line">{{md5check}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="copyUrl(1)">复制文本</el-button>
            </span>
          </el-dialog>
          <p class="goerr" v-show="scope.row.isDirectory==='true'">
            <i class="el-icon-folder"></i><a href="javascript:void(0)"
              @click="gotoItem(scope.row)">{{ scope.row.name }}</a>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="大小" align="center" width="180">
        <template slot-scope="scope">
          <span v-if="!scope.row.fileName.endsWith('.txt')">{{ scope.row.fileSize }}</span>
          <span v-else-if="scope.row.fileName==='文件校验列表.txt'">{{md5InfoSize}}</span>
          <span v-else>{{txtFileSize}}</span>
        </template>
      </el-table-column>
      <el-table-column label="修改时间" align="center" width="180">
        <template slot-scope="scope">
          <span v-if="!scope.row.fileName.endsWith('.txt')">{{ scope.row.fileModifyDate }}</span>
          <span v-else>{{txtModifyDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="looktd">
        <template slot-scope="scope">
          <a v-if="scope.row.fileName==='下载链接列表.txt'" href="javascript:void(0)" class="lookfor"
            @click="exportTxt(scope.row,0)">下载</a>
          <a v-else-if="scope.row.fileName==='文件校验列表.txt'" href="javascript:void(0)" class="lookfor"
            @click="exportTxt(scope.row,1)">下载</a>
          <a v-else href="javascript:void(0)" class="lookfor" @click="downLoadFileNew(scope.row)">下载</a>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background
        layout="sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'cloudDiskOne',
  components: {
  },
  created () {
    // this.path = this.$route.params.path
    // this.name = this.$route.params.name
    // this.readSonFolder(this.path)
    this.orderCode = this.$route.params.orderCode
    this.type = this.$route.params.type
    this.getDownloadUrls()
    this.getOrderFiles()
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 5,
      path: '',
      name: '',
      tableData: [],
      title: '',
      content: '',
      md5check: '',
      orderCode: '',
      txtFileSize: '',
      md5InfoSize: '',
      type: 0,
      txtFormVisible: false
    }
  },
  computed: {
    txtModifyDate () {
      return this.tableData[2].fileModifyDate
    }
  },
  methods: {
    exportTxt (row, type) {
      var saveLink = document.createElement('a')
      if (type === 0) {
        let exportBlob = new Blob([this.content])
        saveLink.href = window.URL.createObjectURL(exportBlob)
        saveLink.download = '下载链接列表.txt'
      } else if (type === 1) {
        let exportBlob = new Blob([this.md5check])
        saveLink.href = window.URL.createObjectURL(exportBlob)
        saveLink.download = '文件校验列表.txt'
      }
      this.fakeClick(saveLink)
    },
    fakeClick (obj) {
      var ev = document.createEvent('MouseEvents')
      ev.initMouseEvent(
        'click',
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
      obj.dispatchEvent(ev)
    },
    getOrderFiles () {
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        orderCode: this.orderCode
      }
      this.sapost('/dmc/account/myCloudDisk', queryParams, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    readSonFolder (path) {
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        path: path
      }
      this.sapost('/dmc/account/readSonFolder', queryParams, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      // this.readSonFolder(this.$route.params.path)
      this.getOrderFiles()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.readSonFolder(this.$route.params.path)
      this.getOrderFiles()
    },
    gotoItem (p) {
      this.$router.push({ name: 'clouddisktwo', params: { lastPath: this.path, lastName: this.name, path: p.path, name: p.name } })
    },
    downLoadFileNew (file) {
      let downloadPath = encodeURI(file.downloadUrl)
      window.location.href = `${downloadPath}`
      return false
    },
    downLoadFile (file) {
      let query = {
        fileName: file.name,
        filePath: file.path
      }
      this.$http({
        method: 'post',
        url: '/dmc/account/downLoadFiles',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: query,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        // 这里res.data是返回的blob对象
        var blob = new Blob([res.data], { type: 'application/actet-stream;charset=utf-8' })
        var contentDisposition = res.headers['content-disposition'] // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        var result = patt.exec(contentDisposition)
        var filename = result[1]
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.style.display = 'none'
        downloadElement.href = href
        downloadElement.download = filename // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      })
    },
    getDownloadUrls () {
      let params = {
        orderCode: this.orderCode
      }
      this.$http({
        method: 'post',
        url: '/dmc/account/getDownloadLinks',
        data: params,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        let { retMsg, retCode, downloadUrls, md5Infos, txtFileSize, md5InfoSize } = res.data
        if (retCode === '0') {
          this.content = downloadUrls
          this.md5check = md5Infos
          this.txtFileSize = txtFileSize
          this.md5InfoSize = md5InfoSize
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    // 隐藏没有文件校验列表0B的行
    tableRowClassName ({ row, rowIndex, page }) {
      if (this.md5InfoSize === '0 B' && row.fileName === '文件校验列表.txt') {
        return 'hidden_box'
      }
      return ''
    },
    showDownloadLink (row, type) {
      this.title = type
      this.txtFormVisible = true
    },
    showTxt (file) {
      let query = {
        fileName: file.name,
        filePath: file.path
      }
      this.$http({
        method: 'post',
        url: '/dmc/account/downLoadFiles',
        data: query,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        var content = res.data
        var contentArr = content.split('下载链接列表')
        this.txtFormVisible = true
        this.title = '下载链接：' + contentArr[0]
        this.content = contentArr[1]
      })
    },
    copyUrl (type) {
      if (type === 0) {
        this.$copyText(this.content).then(r => {
          this.$message.success('链接复制成功')
        })
      } else if (type === 1) {
        this.$copyText(this.md5check).then(r => {
          this.$message.success('文本复制成功')
        })
      }
    }
  }
}
</script>

<style lang="less">
.txtDialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 350px;
  .el-dialog__header {
    background: #fff;
    border-radius: 8px 8px 0 0;
    height: 1.25rem;
    .el-dialog__title {
      line-height: 24px;
      font-size: 18px;
      color: #303133;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #909399;
    }
  }
  .el-dialog__body {
    padding: 30px 20px;
    border-top: #e5e5e5 1px solid;
    border-bottom: #e5e5e5 1px solid;
    max-height: 500px !important;
    min-height: 100px;
    overflow-y: auto;
  }
}
.clouddiskone {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 670px;
  .el-table::before {
    height: 0;
  }
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 15px;
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a {
            color: #b4b8bb;
          }
        }
        li.active,
        li:hover {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
        li.fr {
          float: right;
          margin-right: 0px;
          color: #333;
          a {
            color: #333;
            font-size: 12px;
          }
          a:hover {
            color: #f01400;
          }
        }
        li.fr:hover {
          border-bottom: none;
        }
      }
    }
  }
  .r-title {
    float: right;
    height: 60px;
    line-height: 60px;
    span {
      color: #f01400;
    }
  }
  .pages {
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table__body tr:hover > td {
      background-color: #fef3f3;
    }
    .el-table__body-wrapper td {
      border: none;
    }
    tr:hover {
      .lookfor {
        background-color: #f20d0c;
        color: #fff;
        padding: 3px 29px;
        border-radius: 29px;
        display: inline-block;
      }
      td.looktd {
        padding: 6px 0;
      }
    }
    .cell {
      color: #333;
      i {
        margin-right: 5px;
        display: inline-block;
      }
      i.txticon {
        height: 24px;
        width: 24px;
        background: url("../../assets/img/txt-icon.png") no-repeat center;
        background-size: 100%;
        vertical-align: middle;
      }
      i.zipicon {
        display: inline-block;
        height: 24px;
        width: 24px;
        background: url("../../assets/img/zip-icon.png") no-repeat center;
        background-size: 100%;
        vertical-align: middle;
      }
    }
    .file-name {
      display: inline-block;
      width: 330px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: bottom;
    }
  }
  .goerr {
    font-size: 14px;
    line-height: 30px;
    padding: 10px 0px;
    height: 30px;
    i.el-icon-folder {
      font-size: 26px;
      margin-right: 5px;
      color: #ffb805;
      vertical-align: middle;
    }
    .lookfor {
      float: right;
      margin-right: 70px;
    }
  }
  .goerr:hover {
    background-color: #fef3f3;
    .lookfor {
      background-color: #f20d0c;
      color: #fff;
      padding: 0px 29px;
      border-radius: 29px;
      display: inline-block;
      margin-right: 41px;
    }
  }
  .el-table .hidden_box {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/clouddiskone.vue